import {Injectable} from "@angular/core";
import {BehaviorSubject} from "rxjs";
import { AlwaysProtectedOptions } from "../always-protected/always-protected";

@Injectable({
  providedIn: 'root'
})

export class AlwaysProtectedCheckService {

  private alwaysProtected = new BehaviorSubject<boolean>(false);
  currentAlwaysProtected = this.alwaysProtected.asObservable();
  private alwaysProtectedResult = new BehaviorSubject<AlwaysProtectedOptions[]>([]);
  alwaysProtectedRes = this.alwaysProtectedResult.asObservable();
  private easyProtectPackIdValue = new BehaviorSubject<string>('');
  easyProtectPackIdValueRes = this.easyProtectPackIdValue.asObservable();
  private norton5Count = new BehaviorSubject<number>(0);
  norton5CountRes = this.norton5Count.asObservable();


  public checkAlwaysProtected(data:boolean) {
    this.alwaysProtected.next(data)
  }

  public alwaysProtectedValue(data:AlwaysProtectedOptions[]) {
    this.alwaysProtectedResult.next(data)
  }

  public easyProtectPackId(packId: string) {
    this.easyProtectPackIdValue.next(packId)
  }

  public norton5SubscriptionCount(count: number) {
    this.norton5Count.next(count)
  }
}
